import React from 'react';
import Auxilary from '../../hoc/auxilary'; // this is a higher order component to wrap our stuff so we may render adjacent JSX elements
import classes from './Layout.css';
import ToolBar from '../Navigation/ToolBar/Toolbar';

const layout = (props) =>
(
    <Auxilary>
        <ToolBar/> 
        <main className = {classes.Content}>
            {props.children}
        </main>
    </Auxilary>
);

export default layout;


// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js